var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenShareDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "black",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.75 17.375H16.25C15.6287 17.375 15.125 17.8787 15.125 18.5V27.5C15.125 28.1213 15.6287 28.625 16.25 28.625H29.75C30.3713 28.625 30.875 28.1213 30.875 27.5V18.5C30.875 17.8787 30.3713 17.375 29.75 17.375ZM16.25 16.25C15.0074 16.25 14 17.2574 14 18.5V27.5C14 28.7426 15.0074 29.75 16.25 29.75H29.75C30.9926 29.75 32 28.7426 32 27.5V18.5C32 17.2574 30.9926 16.25 29.75 16.25H16.25Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7758 24.5L18.5 23.3794L23 18.5L27.5 23.3794L26.2242 24.5L23.75 21.8172V27.5H22.25L22.25 21.8172L19.7758 24.5Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenShareDisable);
export default __webpack_public_path__ + "static/media/screenShareDisable.e6705f3e4a397da28c44e8fb76c49dd2.svg";
export { ForwardRef as ReactComponent };